module.exports = __webpack_public_path__ + "img/3_Bericht_Pause.e965ad3a.svg";